
import { Vue, Component, Ref } from 'vue-property-decorator';

@Component
export default class FedExEulaStep extends Vue {
  @Ref('eulaContainer') eulaContainer!: HTMLDivElement;

  private accepted = false;

  private hasScrolledToBottom = false;

  mounted(): void {
    this.checkScrollPosition();
  }

  private onScroll(): void {
    this.checkScrollPosition();
  }

  private checkScrollPosition(): void {
    if (this.hasScrolledToBottom) return;
    const el = this.eulaContainer;
    if (!el) return;

    const threshold = 20;
    if (el.scrollHeight - el.scrollTop - el.clientHeight <= threshold) {
      this.hasScrolledToBottom = true;
    }
  }
}
